import Component from '@glimmer/component'
import { service } from '@ember/service'
import { PageHeader } from 'teacher-ui-client/components/page-header'
import { t } from 'ember-intl'
import { TabGroupComponent } from 'teacher-ui-client/components/tab-group'
import { BookModal } from 'teacher-ui-client/components/book-library/book-modal'
import type BookLibraryController from 'teacher-ui-client/subscription-type/book-library/controller'
import type BookLibraryCollectionService from 'teacher-ui-client/services/book-library/collection'
import { hash } from '@ember/helper'
import { themeKey } from 'teacher-ui-client/helpers/theme-key'
import { ThemeKeys } from 'teacher-ui-client/utils/themes'
import { TAB_TYPE_KEYS } from 'teacher-ui-client/components/tab-group/tab-types'
import RouteTemplate from 'ember-route-template'

interface Signature {
  Args: {
    controller: BookLibraryController
  }
}
export class BookLibraryPage extends Component<Signature> {
  @service('book-library/collection') collectionService!: BookLibraryCollectionService

  <template>
    <div class="m-0 w-full grow">
      <PageHeader>
        <:title>
          <h1>
            {{t "bookLibrary.name"}}
          </h1>
        </:title>
      </PageHeader>
      <TabGroupComponent class="mx-24" @theme={{ThemeKeys.blue}} @tabType={{TAB_TYPE_KEYS.underline}} as |tabGroup|>
        <tabGroup.linkToTab @route="subscription-type.book-library.search">
          {{t "bookLibrary.pages.search.name"}}
        </tabGroup.linkToTab>
        <tabGroup.linkToTab @route="subscription-type.book-library.collection">
          <span>{{t "bookLibrary.pages.collections.name"}}</span>
        </tabGroup.linkToTab>
        <tabGroup.linkToTab
          @route="subscription-type.book-library.shares.index.by-collection"
          @query={{hash schoolClassId=@controller.SchoolClassOptionTypes.My}}
          @currentWhen="subscription-type.book-library.shares"
        >
          <span>{{t "bookLibrary.pages.sharedCollections.name"}}</span>
        </tabGroup.linkToTab>
      </TabGroupComponent>
      <div class="my-8">
        {{outlet}}
      </div>
    </div>
    {{#if this.collectionService.loadAllMyCollections.last.isSuccessful}}
      <BookModal
        @bookId={{@controller.bookId}}
        @isSubco={{@controller.isSubco}}
        @collections={{this.collectionService.allMyCollections}}
        @showBookModal={{Boolean @controller.bookId}}
        @closeBookModal={{@controller.closeBookModal}}
        @theme={{themeKey @controller.subscriptionType.current}}
      />
    {{/if}}
  </template>
}

export default RouteTemplate(BookLibraryPage)
